import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import { motion, MotionStyle } from 'framer-motion';

import Brand from '../Brand/Brand';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import User from '../User/User';
import getMenu from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import Tooltips from '../../components/bootstrap/Tooltips';
import useAsideTouch from '../../hooks/useAsideTouch';
import AuthContext from '../../contexts/authContext';

const Aside = () => {
	const { userData } = useContext(AuthContext);
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();
	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';
	const constraintsRef = useRef(null);

	const menu = getMenu(userData.role?.id!);

	return (
		<>
			<motion.aside
				style={asideStyle as MotionStyle}
				className={classNames(
					'aside',
					{ open: asideStatus },
					{
						'aside-touch-bar': hasTouchButton && isModernDesign,
						'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
						'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
					},
				)}>
				<div className='aside-head'>
					<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
				</div>
				<div className='aside-body'>
					{menu?.dashboardPages && (
						<>
							<Navigation menu={menu.dashboardPages} id='aside-dashboard' />
							<NavigationLine />
						</>
					)}
					{menu?.dataPages && (
						<>
							<Navigation menu={menu.dataPages} id='aside-data-pages' />
							<NavigationLine />
						</>
					)}
					{menu?.activityPages && (
						<>
							<Navigation menu={menu.activityPages} id='aside-data-pages' />
							<NavigationLine />
						</>
					)}
					{menu?.masterPages && (
						<>
							<Navigation menu={menu.masterPages} id='aside-master-pages' />
							<NavigationLine />
						</>
					)}
					{menu?.reportPages && (
						<>
							<Navigation menu={menu.reportPages} id='aside-report-pages' />
							<NavigationLine />
						</>
					)}
					{menu?.settingPages && (
						<>
							<Navigation menu={menu.settingPages} id='aside-setting-pages' />
							<NavigationLine />
						</>
					)}
				</div>
				<div className='aside-foot'>
					<User />
				</div>
			</motion.aside>
			{asideStatus && hasTouchButton && isModernDesign && (
				<>
					<motion.div className='aside-drag-area' ref={constraintsRef} />
					<Tooltips title='Toggle Aside' flip={['top', 'right']}>
						<motion.div
							className='aside-touch'
							drag='x'
							whileDrag={{ scale: 1.2 }}
							whileHover={{ scale: 1.1 }}
							dragConstraints={constraintsRef}
							// onDrag={(event, info) => console.log(info.point.x, info.point.y)}
							dragElastic={0.1}
							style={{ x, zIndex: 1039 }}
							onClick={() => x.set(x.get() === 0 ? asideWidthWithSpace : 0)}
						/>
					</Tooltips>
				</>
			)}
		</>
	);
};

export default Aside;
